<template>
    <div class="form-section">
        <div class="decor-one">
            <div class="fill"></div>
            <div></div>
            <div></div>
            <div></div>
            <div class="fill"></div>
            <div class="fill"></div>
            <div></div>
            <div class="fill"></div>
            <div class="fill"></div>
            <div class="fill"></div>
            <div class="fill"></div>
            <div></div>
            <div></div>
            <div class="fill"></div>
            <div></div>
            <div></div>
        </div>
        <div class="form-wrapper">
            <img :src="logoImgUrl" class="company-icon-iot" :class="this.logoClassFlower" alt="Tentacles Logo"/>
            <span class="form-title">Tentacles IoT</span>
            <div class="slide-description">
                {{ $t('login.third') }}
            </div>
            <div class="form">
                <div class="title">
                    {{ $t('login.log') }} <span>{{ $t('login.in') }}</span>
                </div>
                <div class="subtitle">
                    {{ $t('login.desc') }}
                </div>
                <form class="form" @submit.prevent="logInUser">
                    <div class="input-wrapper">
                        <label for="username">{{ $t('login.username') }}</label>
                        <input id="username" type="text" name="_username" value=""
                               required="required" v-model="username">
                    </div>
                    <div class="input-wrapper">
                        <label for="password">{{ $t('login.password') }}</label>
                        <input id="password" type="password" name="_password" value=""
                               required="required" v-model="password">
                    </div>
                    <div class="input-wrapper">
                        <button type="submit">{{ $t('buttons.login') }}</button>
                    </div>
                </form>
            </div>
            <div class="language-picker">
                <div class="wrapper" v-for="(lang,index) in languages">
                    <div class="lang" v-on:click="changeLanguage(lang)"
                         v-bind:class="{'lang--selected':$i18n.locale === lang.name}">{{lang.name}}
                    </div>
                    <span v-if="languages.length - 1 !== index">/</span>
                </div>
            </div>
        </div>
        <div></div>
        <div></div>
    </div>
</template>

<script>
import languages from '@/config/languages';
import {mapGetters} from 'vuex';

export default {
  name: 'LoginForm',
  data() {
    return {
      username: '',
      password: '',
      env_emeta: process.env.VUE_APP_ENV_EMETA,
      env_tentacles: process.env.VUE_APP_ENV_TENTACLES,
      env_etentacles: process.env.VUE_APP_ENV_ETENTACLES,
      env_flower: process.env.VUE_APP_ENV_FLOWER,
      logoImgUrl: process.env.VUE_APP_ENVIRONMENT === process.env.VUE_APP_ENV_FLOWER ? '/flower.png' : '/Tentacles_IoT_logo.png',

    };
  },
  computed: {
    ...mapGetters('tentacle', ['user']),
    languages() {
      return languages;
    },
    logoClassFlower() {
      return process.env.VUE_APP_ENVIRONMENT === process.env.VUE_APP_ENV_FLOWER ? 'flower' : '';
    }
  },
  methods: {
    showInEnv(type) {
      if (Array.isArray(type)) {
        return type.includes(process.env.VUE_APP_ENVIRONMENT);
      }
      return process.env.VUE_APP_ENVIRONMENT === type;
    },
    changeLanguage(lang) {
      const { params } = this.$route;
      params.lang = lang.name.toLowerCase();
      const { query } = this.$route;

      this.$router.push({ name: this.$route.name, params, query });
      this.$i18n.locale = lang.name;
    },
    logInUser() {
      if (this.username.length > 0 && this.password.length > 0) {
        this.$store.dispatch('tentacle/setLogin', {
          username: this.username,
          password: this.password,
        }).then((response) => {
          if (response && response.status === 200) {
            this.flash(this.$t('login.successful'), 'success');
            this.$router.push({ name: 'dashboard', params: {'lang': this.user.lang.name.toLowerCase()} });
          } else {
            this.flash(`Login: ${response.data.message}`, 'error');
          }
        });
      }
    },
  },
};
</script>

<style lang="scss">
    .form-section {
        width: 80rem;
        display: flex;
        flex-direction: column;
        position: relative;
        flex-shrink: 0;
        max-width: 100vw;

        .decor-one {
            position: absolute;
            top: 12rem;
            left: 0;
            display: grid;
            grid-template-columns: 3rem 3rem 3rem 3rem;
            grid-template-rows: 3rem 3rem 3rem 3rem;
            @media only screen and (max-width: 700px) {
                display: none;
            }

            .fill {
                background: $company-color-login;
            }
        }

        .form-wrapper {
            width: 90%;
            justify-self: center;
            min-height: 51rem;
            max-width: 40rem;
            align-self: center;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            img.flower {
              max-width: 40em;
            }

            .company-icon {
                width: 7em;
                padding-bottom: 10em;
                padding-top: 5em;
                @media only screen and (min-width: 1501px) {
                    margin-bottom: 12em;
                }
            }

            .company-icon-iot {
                width: 97em;
                padding-top: 5em;
                @media only screen and (min-width: 1501px) {
                    margin-bottom: 0em;
                }
            }

            .form-title {
                display: block;
                margin-top: 1em;
                margin-bottom: 0.35em;
                width: 100%;
                font-size: 3.7rem;
                font-weight: 700;
                color: #122404;
                border-bottom: 4px solid $company-color-login;
                padding-bottom: 0.2em;
                @media only screen and (max-width: 470px) {
                    font-size: 8vw;
                }
                @media only screen and (min-width: 1501px) {
                    display: none;
                }
            }

            .slide-description {
                font-size: 1.3rem;
                font-weight: 500;
                color: #8c8c94;
                line-height: 1.75rem;
                padding-right: 1em;
                padding-left: 0;
                margin-bottom: 1em;
                @media only screen and (min-width: 1501px) {
                    display: none;
                }
            }

            .form {
                width: 100%;
                color: #122404 !important;

                .title {
                    font-size: 4rem;
                    font-weight: 700;

                    span {
                        color: $company-color-light;
                    }
                }

                .subtitle {
                    font-size: 1.3rem;
                    font-weight: 500;
                    margin-top: 0.5rem;
                    color: #9a9a9a;
                }
            }

            .form {
                margin: 8rem 0 5rem;
                @media only screen and (max-width: 991px) {
                    margin: 4rem 0 5rem;
                }

                label {
                    font-weight: 500;
                    font-size: 1.3rem;
                    margin-bottom: 0.6rem;
                    display: block;
                    color: #9a9a9a;
                }

                input[type=text], input[type=password] {
                    height: 5.5rem;
                    width: 100%;
                    border-radius: 0.5rem;
                    border: 2px solid transparent;
                    padding: 0 1rem;
                    font-size: 1.6rem;
                    color: #8c8c94;
                    font-weight: 500;
                    background: #e5e5e5;
                    transition: all 0.4s;

                    &:focus {
                        background: transparent;
                        border: 2px solid $company-color-login;
                    }
                }

                button {
                    width: 100%;
                    border: none;
                    background-color: $company-color-login;
                    color: white;
                    height: 5.5rem;
                    font-weight: 600;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    border-radius: 0.5rem;
                    transition: all 0.4s;
                }
            }
        }

        .language-picker {
            display: flex;
            width: 100%;
            align-items: center;
            justify-content: center;
            font-size: 1.3rem;
            font-weight: 600;
            color: #bbb;

            .wrapper {
                display: flex;
                align-items: center;
            }

            .lang {
                cursor: pointer;
                font-size: 1.6rem;
                font-weight: 600;
                margin: 0.25em;
                transition: all 0.2s ease-in-out;

                &:hover {
                    color: #aad249;
                }

                &--selected {
                    color: $company-color-login;
                }
            }
        }
    }
</style>
